import { clientWithoutInterceptors } from '../utils/http';
import config from '../config';

export async function getTrueLayerUrl(): Promise<Response> {
  const response = await clientWithoutInterceptors.post('/api/generate-true-layer-redirect-url/', {
    env: config.get().otsEnv,
  });
  return response.data.url;
}

export async function authenticateTrueLayerCode(code: string): Promise<boolean> {
  const response = await clientWithoutInterceptors.post('/api/authenticate/', {
    code,
  });
  return response.status === 200;
}
